export default __webpack_public_path__ + "static/media/Wall_Grey.256.06ce7556.png";